import React from 'react';
import { useHistory } from 'react-router-dom';
import PlatformModal from '../../ui_kit/modals/platform_modal';

function mentorLabel(mentorName) {
  const trimmed = mentorName?.trim();
  return trimmed || 'your mentor';
}

export default function PostConversationModal({ postConversationPath, mentorName, onDismiss, onClose }) {
  const history = useHistory();
  const mentor = mentorLabel(mentorName);

  const onSubmit = () => {
    history.push(postConversationPath);
    if (typeof onClose === 'function') onClose();
  };

  return (
    <PlatformModal
      title={`How was your conversation with ${mentor}?`}
      setModal={onDismiss}
      width={8}
      content={
        <div className='container'>
          <div className='row'>
            <p>
              We hope your conversation with {mentor} helped you feel supported, understood, and less alone in your
              journey.
            </p>
            <p>
              Your feedback directly shapes how we train and match mentors for future patients navigating a diagnosis
              like yours. It takes less than 2 minutes, and every response helps us make this program better for the
              next person who needs it.
            </p>
          </div>
        </div>
      }
      submitCta={'Start survey'}
      onSubmit={onSubmit}
      cancelCta={'Dismiss'}
    />
  );
}
